module.exports = __webpack_public_path__ + "static/media/supveto.ef5aa3e5.png";